import { GlobalConfiguration } from '../../models/GlobalConfiguration';
import ExtendedLiquid from '../../services/ExtendedLiquid';

export function generateInvestmentMessage(
  config: GlobalConfiguration | null | undefined,
  options?: { isObserver?: boolean; hasSubmitted?: boolean },
): string {
  const minInvestment = config?.investorMinimumInvestment || 100000;
  const increment = config?.investorInvestmentIncrement || 25000;
  const { isObserver = false, hasSubmitted = false } = options ?? {};

  if (isObserver) {
    if (hasSubmitted) {
      return 'You can suggest an updated indicative investment by entering it below.';
    }
    return 'You can suggest an indicative investment by entering it below.';
  }

  let message = 'Confirm your indicative investment value';
  message += `. The minimum investment is ${ExtendedLiquid.currencyMillions(minInvestment, false)}`;

  if (increment > 1) {
    message += ` with increments thereafter of ${ExtendedLiquid.currencyMillions(increment, false)}`;
  }

  message += '.';
  return message;
}
